/* eslint-disable no-console */
import {Button, Flex} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import titleLogo from '../../assets/LogoMain.svg';
import logo from '../../assets/TitleLogo.svg';
import {Routes} from '../../constants/Routes';

const LogoMenu: React.FC<{
  logoPlace?: React.CSSProperties;
  setProduct: React.Dispatch<React.SetStateAction<string>>;
}> = ({logoPlace, setProduct}) => {
  // const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  // const products = [
  //   {
  //     title: 'Carbon Accounting',
  //     key: 'ca',
  //     icon: <DashboardOutlined style={{color: '#435B37', fontSize: '50px'}} />,
  //     hidden: false,
  //     href: undefined
  //   },
  //   {
  //     title: 'ESG',
  //     key: 'esg',
  //     icon: <SettingOutlined style={{color: '#435B37', fontSize: '50px'}} />,
  //     hidden: false,
  //     href: undefined
  //   },
  //   {
  //     title: 'Strategy',
  //     key: 'strategy',
  //     icon: <TrophyOutlined style={{color: '#435B37', fontSize: '50px'}} />,
  //     hidden: true,
  //     href: 'https://dev-strategy.bharatcarbon.earth'
  //   }
  // ];

  // const handleOpenChange = (newOpen: boolean) => {
  //   setOpen(newOpen);
  // };

  return (
    <Flex
      align="center"
      justify="center"
      className="logoMenu"
      style={logoPlace}
    >
      <Button type="text" className="textButton" style={{padding: '4px 0px'}}>
        <Flex align="center" gap={0}>
          {/* <Popover
            placement="bottomLeft"
            arrow={false}
            trigger={['click']}
            open={open}
            // title="Products"
            style={{width: 'max-content !important'}}
            overlayClassName="productHover"
            onOpenChange={handleOpenChange}
            content={
              <Flex
                vertical={false}
                align="flex-start"
                justify="space-between"
                className="productFlex"
              >
                {products
                  // .filter((a) => !a.hidden)
                  .map((item) => {
                    return (
                      <a
                        href={item?.href}
                        target="_blank"
                        rel="noreferrer"
                        key={item.key}
                      >
                        <Flex
                          vertical={true}
                          align="center"
                          justify="center"
                          className={`singleProduct ${
                            product === item.key ? 'selected' : ''
                          }`}
                          gap={5}
                          onClick={() => {
                            if (item?.key === 'strategy') {
                              setOpen(false);
                            } else {
                              setProduct(item.key);
                              setOpen(false);
                            }
                          }}
                        >
                          {item.icon}
                          <div
                            style={{
                              fontSize: '10px',
                              textAlign: 'center',
                              fontWeight: 'bold',
                              lineHeight: '1rem',
                              textOverflow: 'ellipsis',
                              color: '#435B37'
                            }}
                          >
                            {item.title}
                          </div>
                        </Flex>
                      </a>
                    );
                  })}
              </Flex>
            }
          >
            <img src={titleLogo} alt="titleLogo" className="titleLogo" />
          </Popover> */}
          <img
            src={titleLogo}
            alt="titleLogo"
            className="titleLogo"
            onClick={() => {
              navigate(`${Routes.HOME}`);
              setProduct('');
            }}
          />
          <img
            src={logo}
            alt="logo"
            className="logo"
            onClick={() => {
              navigate(`${Routes.HOME}`);
              setProduct('');
            }}
          />
        </Flex>
      </Button>
    </Flex>
  );
};

export default LogoMenu;
